import axios from 'axios';

// Configuración global de Axios
axios.defaults.withCredentials = true;

const axiosInstance = axios.create({
    withCredentials: true,
   // baseURL: 'http://localhost/backendcatequesis/public/api',
    // baseURL: 'http://localhost:8000/api',
    baseURL: 'https://apicate.santodomingocartagena.com/api', // URL base de la API
    // timeout: 5000, // Tiempo de espera para las solicitudes
  });

export default axiosInstance;